import { createAction, props, union } from '@ngrx/store';
import { RfrMonStackQueryI } from 'src/app/api/rfr-mon-stack/rfr-mon-stack.query.int';
import { RfrMonStackResponseI } from 'src/app/api/rfr-mon-stack/rfr-mon-stack.result.int';

export const load = createAction('[RFR MON / Containers] Get', props<{ query: RfrMonStackQueryI }>());
export const received = createAction('[RFR MON / Containers] Received', props<{ data: RfrMonStackResponseI }>());
export const reset = createAction('[RFR MON / Containers] Reset', props<Record<string, unknown>>());
export const error = createAction('[RFR MON / Containers] Error', props<{ messageText: string }>());

const actions = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof actions;
